import { render, staticRenderFns } from "./taskStatusCell.vue?vue&type=template&id=3bdb4a9c&scoped=true"
import script from "./taskStatusCell.vue?vue&type=script&lang=js"
export * from "./taskStatusCell.vue?vue&type=script&lang=js"
import style0 from "./taskStatusCell.vue?vue&type=style&index=0&id=3bdb4a9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb4a9c",
  null
  
)

export default component.exports